// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1ORdI","modalFooterButton":"ModalNotes_modalFooterButton__26LlY"};